<template>
  <section>
    <div class="title">Contact</div>
    <div class="list">
      <div class="item">
        <i class="email" />
        <a href="mailto:sungmoon@inpock.com">sungmoon@inpock.com</a>
      </div>
      <div class="item">
        <i class="fb" />

        <a href="http://www.facebook.com/godmoongoodman" target="_blank">@godmoongoodman</a>
      </div>
      <div class="item">
        <i class="insta" />

        <a href="https://www.instagram.com/mo00oo0ny/" target="_blank">@mo00oo0ny</a>
      </div>
      <div class="item">
        <i class="linkedin" />

        <a href="https://www.linkedin.com/in/sunmoon-yoon-8019b3184/" target="_blank">Sungmoon Yoon</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
section {
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
    letter-spacing: -1px;
  }
}

.item {
  display: flex;
  margin-bottom: 8px;
}

i {
  width: 24px;
  height: 24px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 8px;
  &.fb {
    background-image: url("../assets/fb.svg");
  }
  &.insta {
    background-image: url("../assets/instagram.svg");
  }
  &.email {
    background-image: url("../assets/email.svg");
  }
  &.linkedin {
    background-image: url("../assets/linkedin.svg");
  }
}

a,
a:hover {
  text-decoration: none;
  color: black;
}
</style>
